// Lazy loader for the Google Maps JS API (Places library). Singleton promise so
// it loads at most once. Resolves false if no key is configured or loading fails,
// so callers can fall back gracefully to a plain text input.
let promise: Promise<boolean> | null = null;

export function loadGoogleMaps(): Promise<boolean> {
  if (promise) return promise;
  const key = __GOOGLE_MAPS_API_KEY__;
  if (!key) return (promise = Promise.resolve(false));
  if (window.google?.maps?.places) return (promise = Promise.resolve(true));

  promise = new Promise<boolean>((resolve) => {
    const s = document.createElement('script');
    s.src = `https://maps.googleapis.com/maps/api/js?key=${key}&libraries=places&loading=async`;
    s.async = true;
    s.defer = true;
    s.onload = () => resolve(Boolean(window.google?.maps?.places));
    s.onerror = () => resolve(false);
    document.head.appendChild(s);
  });
  return promise;
}
